// in src/app/core/shared/utility/date.utils.ts

export class DateUtils {
  public static toInputFormat(date: string | Date | null | undefined): string | null {
    if (!date) {
      return null;
    }
    try {
      return new Date(date).toISOString().slice(0, 10);
    } catch (e) {
      console.error('Data non valida:', date, e);
      return null;
    }
  }

  public static toApiFormat(
    date: string | Date | null | undefined,
    position: 'start' | 'end',
  ): string | null {
    if (!date) {
      return null;
    }
    try {
      const dateObj = new Date(date);
      if (position === 'start') {
        dateObj.setUTCHours(0, 0, 0, 0);
      } else {
        dateObj.setUTCHours(23, 59, 59, 999);
      }
      return dateObj.toISOString().slice(0, 19) + 'Z';
    } catch (e) {
      console.error('Data non valida:', date, e);
      return null;
    }
  }

  public static toDisplayFormat(
    date: string | Date | null | undefined,
    locale: string = 'it-IT',
    options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
  ): string {
    if (!date) {
      return '';
    }
    try {
      return new Date(date).toLocaleDateString(locale, options);
    } catch (e) {
      console.error('Data non valida:', date, e);
      return '';
    }
  }
}
